import * as React from 'react';
import {connect} from "react-redux";
import {Department} from "../../models/Department";
import {ApplicationState} from "../../store";
import {DepartmentList}  from '../components/DepartmentList';
import {ColumnData} from '../../models/ColumnData';
import {TabsService} from '../TabsService';
import {Tab, TabTypes} from '../Tab';
import {actionDepartmentsFetchAll, actionDepartmentsDelete, actionDeleteDepartments} from '../../store/departments/actions';
import {Button} from "@material-ui/core";
import AddIcon from "@material-ui/icons/AddCircleOutlineRounded";
import {t} from "../../core/localization";

export interface DepartmentsTabProps {
	departments: Department[]
	tab: Tab
}

export interface DepartmentsTabState {
}

function mapStateToProps(state: ApplicationState) {
	return {
		departments: state.departments.list,
		tab: state.tabs.active
	};
}

class DepartmentsTab extends React.Component<DepartmentsTabProps, DepartmentsTabState> {

	constructor(props: DepartmentsTabProps) {
		super(props)
	}

	componentWillMount() {
	}

	componentWillReceiveProps(nextProps: DepartmentsTabProps) {
	}

	componentDidMount() {
		actionDepartmentsFetchAll();
	}

	onOpenClick(department: Department){
		TabsService.createTab(t.Department + ' ' + department.title, TabTypes.DEPARTMENTS_NEW, department)
	}

	onCopyClick(department: Department){
		TabsService.createTab(t.Department + ' ' + department.title, TabTypes.DEPARTMENTS_NEW, { ...department, id: null })
	}

	onDeleteClick(department: Department){
		actionDepartmentsDelete(department);
	}

	onActionDeleteClick(departments: Department[]){
		actionDeleteDepartments(departments);
	}

	render(): React.ReactNode {

		const { departments } = this.props;

		const columns = [
			new ColumnData(t.Name, "title" ),
			new ColumnData(t.Description, "description" ),
		];

		return (
			<div style={{padding: '10px'}}>
				<div style={{marginBottom: '10px'}}><Button onClick={this.onNewClick} color="primary" style={{}}><AddIcon />{t.CreateNewDepartment}</Button></div>
				<DepartmentList
					columns={columns}
					items={departments}
					title={t.Department}
					onOpenClick={(department: Department) => this.onOpenClick(department)}
					onCopyClick={(department: Department) => this.onCopyClick(department)}
					onDeleteClick={(department: Department) => this.onDeleteClick(department)}
					onActionDeleteClick={(departments: Department[]) => this.onActionDeleteClick(departments)}
					tab={this.props.tab}
				/>

			</div>
		);
	}

	onNewClick() {
		TabsService.createTab(t.NewDepartment, TabTypes.DEPARTMENTS_NEW, new Department())
	}
}

export default connect(mapStateToProps)(DepartmentsTab);
